"use client";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { scrollToElement } from "@/utils/scroll";
import { adjustStringAnchor } from "@/utils/slug";
import React from "react";

type Props = {};

const MobileCategoryBar = (props: any) => {
  const [value, setValue] = React.useState("");
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (value !== "") {
      scrollToElement(value, 120);
    }
  }, [value]);
  React.useEffect(() => {
    // console.log(open);
  }, [open]);

  return (
    <div className="backdrop-blur-xs border-t-1 sticky top-[76px] z-[4] mb-12 border-secondary-800 bg-secondary-300/80 p-4 py-4 backdrop-blur-md">
      {open && <div className="fixed right-0 top-0 h-screen w-full" />}
      <Select value={value} onValueChange={setValue} onOpenChange={setOpen}>
        <SelectTrigger className="z-[4] mx-auto w-full border-secondary-600 bg-secondary-800 font-bold text-white">
          <SelectValue
            className=" line-clamp-1 "
            placeholder="Wählen Sie eine Kategorie"
          />
        </SelectTrigger>
        <SelectContent className="z-[10] h-full w-full bg-secondary-500">
          <SelectGroup>
            {Object.keys(props).map((key, index) => {
              return (
                <SelectItem
                  value={adjustStringAnchor(key)}
                  className="z-[10] bg-secondary-100"
                >
                  {key}
                </SelectItem>
              );
            })}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default MobileCategoryBar;
